// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "-legacy." + {"22":"1345fc67","159":"7e3bd213","174":"991c859c","270":"3bcbf8fd","439":"43eaee0b","494":"9b4a8ef6","521":"406ddc31","613":"28f0ceb4","642":"d72c95fe","876":"f83923f7","906":"52a36f38"}[chunkId] + ".js";
};